import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Layout from '../../parts/Layout';
import { httpRequest, httpAuthHeaders } from '../../../services/httpService';
import helpers from '../../../services/helpers';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import initTreeView from '../../../services/initTreeView';
import ButtonGroupSelection from '../../elements/ButtonGroupSelection';
import store from '../../../services/store';
import DropDownSelection from '../../elements/DropDownSelection';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { getApiData } from '../../../services/apiService';
import { Calendar } from 'primereact/calendar';
 
export default function ReportServiceHub (){
    const [data_loaded, setDataLoaded] = useState(0);
    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [data_table, setDataTable] = useState([]);
    const [search_key, setSearchKey] = useState('');
    const [enums, setEnums] = useState([]);
    const [filter_by, setFilterBy] = useState('');
    const [filters, setFilters] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null,

        //product_type : '',
        //product_status: '',
        //brand: '',
        //category: '',
        //stock_level: '',,
        dates: []
    });

    useEffect(() => {
        initTreeView()
        getEnums()
        const filter = helpers.getURLParams('filter') ?? ''
        if(filter) {
            let value = ''
            if(filter === 'product_status' || filter === 'product_type'){
                value = 1
            }

            setFilterBy(filter)
            let new_state = { [filter] : value }
            setFilters({ ...filters, ...new_state });
        }
    }, []);

    useEffect(() => {
        fetchDataList()
    }, [
        filters.dates,
        //filters.product_status,
        //filters.category,
        //filters.brand,
        //filters.stock_level,
    ]);

    useEffect(() => {
        displayDataTable(record_data)
    }, [filters.sortOrder]);

    // useEffect(() => {
    //     displayDataTable(record_data)
    // }, [
    //     selected_items, 
    //     selected_all
    // ]);

    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;

                if(name == 'warranty_status') value = 'active'
            } else {
                value = 0;

                if(name == 'warranty_status') value = 'expired'
            }
        }
        else if (e.target.type === "file") {
          value = e.target.files[0]
        }

        let new_state = { [name]: value }

        setFilters({ ...filters, ...new_state });
    }

    function inputDateChange(e){
        let { value, name } = e.target;
        let new_state = { 'dates': value }

        if(!value){
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            new_state = { 'dates': [firstDay, lastDay] }
        }
        setFilters({ ...filters, ...new_state });
    }


    async function fetchDataList(condition = {
        "page": '',
        "search": '',
        "per_page": '',
        "product_type": ''
    }){
        const page = condition.page ?? filters.page
        const per_page = condition.per_page ?? filters.rows
        const search = condition.search ?? search_key

        let filter = '?store_id='+helpers.getStoreID()+'&'

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }

        // if(filters.product_type){
        //     filter += 'product_type='+filters.product_type+'&'
        // }
        // if(filters.product_status){
        //     filter += 'status='+filters.product_status+'&'
        // }
        // if(filters.category){
        //     filter += 'category='+filters.category+'&'
        // }
        // if(filters.brand){
        //     filter += 'brand='+filters.brand+'&'
        // }
        // if(filters.stock_level){
        //     filter += 'stock='+filters.stock_level+'&'
        // }
        if(typeof filters.dates[0] !== 'undefined' || typeof filters.dates[1] !== 'undefined'){
            const request_from = helpers.formatDate(filters.dates[0])
            if(request_from){
                filter += 'request_from='+request_from+'&'
            }

            const request_to = filters.dates[1] ? helpers.formatDate(filters.dates[1]) : ''
            if(request_to){
                filter += 'request_to='+request_to+'&'
            }

        }


        filter = filter.slice(0, -1)

        setLoading(1)

        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/reports${filter}`)
        const res = await getApiData(endpoint)
        

        if(res){
            setLoading(0)
            setDataLoaded(1)
            setRecordData(res)
            displayDataTable(res)
        }

        // const url = helpers.createUrl('V1/reports/item'+filter)

        // httpRequest(url, "GET", {}, true)
        //     .then((res) => {
        //         setRecordData(res)
        //         setLoading(0)
        //         displayDataTable(res)
        //         setDataLoaded(1)
        //     })
        //     .catch((err) => {
        //         setLoading(0)

        //         Swal.fire({
        //             title: "Error!",
        //             text: err.message,
        //             icon: "error",
        //             confirmButtonText: "OK",
        //         });
        //     }); 
    }

    

    function getEnums(){
        setLoading(1)
        const url = helpers.createUrl('V1/enums/item?store_id='+helpers.getStoreID())
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setLoading(0)
            setEnums(res)
        })
        .catch((err) => {
            setLoading(0)
        }); 
    }

    function exportReport(){
        const page = filters.page ?? ''
        const per_page = filters.rows ?? ''
        const search = search_key ?? ''
        const product_type = filters.product_type

        let filter = '?store_id='+helpers.getStoreID()+'&export=excel&'

        // if(page){
        //     filter += 'page='+page+'&'
        // }
        // if(per_page){
        //     filter += 'per_page='+per_page+'&'
        // }
        if(search){
            filter += 'search='+search+'&'
        }
        if(filters.product_type){
            filter += 'product_type='+filters.product_type+'&'
        }
        if(filters.product_status){
            filter += 'status='+filters.product_status+'&'
        }
        if(filters.category){
            filter += 'category='+filters.category+'&'
        }
        if(filters.brand){
            filter += 'brand='+filters.brand+'&'
        }
        if(filters.stock_level){
            filter += 'stock='+filters.stock_level+'&'
        }

        filter = filter.slice(0, -1)

        setLoading(1)
        const today = new Date();
        const month = today.getMonth() + 1;
        const date = today.getFullYear() + '-' + month + '-' + today.getDate() + '_' +  today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds();
        const file_name = 'service-request-reports-' + date + '.xlsx';


        //const url = helpers.createUrl('V1/reports/item'+filter)
        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/reports${filter}`)
        
        fetch(endpoint, {
            method: 'GET',
            headers: httpAuthHeaders(),
        })
        .then((res) => {
          if(res.ok) {
            return res.blob();
          }
          
          const json = res.json();
          const status_code = res.status;
  
          if (!res.ok) {
              let errorCode = json.error_code ? json.error_code : 'unknown';
              let message = json.message ? json.message : (res.statusText ? res.statusText : 'Request failed');
              let data = json.error ? json.error: '';
              let status = json.status ? json.status: '';
              let error = { data: data, message: message, error_code: errorCode, status_code: status_code, status: status };
  
              if (status_code === 422) error = { ...error, ...json };
  
              return Promise.reject(error);
          }
        })
        .then(blob => {
            
            Swal.fire("Export Completed", "Export successfully completed. Please check your downloads.", "success");

            var url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.setAttribute("style", "display: none");
            a.setAttribute("href", url);
            a.download = file_name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.parentNode.removeChild(a);
            setLoading(0);
        })
        .catch(err => {
          Swal.fire("Error", "Export failed", "error");
          setLoading(0);
        });
    }
    

    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchDataList({
            "page": filters.page + 1,
            "search": value
        })
    }

    function displayDataTable(data){
        setDataTable(
            <DataTable 
                dataKey={data.product_variant_id}
                value={data.data} 
                size="small"
                paginator 
                rows={data.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data.total}
                onPage={onPage}
                first={filters.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                scrollHeight="700px"
                scrollable
                stripedRows
                resizableColumns
                emptyMessage="No data to display"
            >
                <Column field="id" header="ID" style={{ width: '100px' }} headerStyle={{ background: '#f9fafb' }}/>
                <Column field="service_no" header="Service No" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="request_date" header="Request Date" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="customer_name" header="Customer" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="service_type_name" header="Service Type" headerStyle={{ background: '#f9fafb' }}/>
                <Column 
                    field="sub_service_type_name" 
                    header="Sub Service Type" 
                    headerStyle={{ background: '#f9fafb' }}
                    body={({sub_service_type_name})=> sub_service_type_name ? sub_service_type_name : '---'}
                />
                <Column header="Status" headerStyle={{ background: '#f9fafb' }} body={({status, status_name})=> <h5>{helpers.displayServiceRequestStatusBadge(status, status_name)}</h5>} />
                {/* <Column className='text-center' field="product_variant_id" header="Item&nbsp;ID" style={{ width: '100px' }} headerStyle={{ background: '#f9fafb' }}/>
                <Column 
                    field="product_name" 
                    header="Name" 
                    body={({product_name, product_variant_name})=> `${product_name} (${product_variant_name})`}
                    headerStyle={{ background: '#f9fafb' }}
                 />
                <Column field="product_type_id" body={({product_type_id})=> product_type_id === 1 ? 'Goods' : 'Services'} header="Type" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="product_code" body={({product_code})=> product_code ? product_code : ''} header="Code" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="barcode" body={({barcode})=> barcode ? barcode : ''} header="Barcode" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="category_name" header="Category" body={({category_name})=> category_name ? category_name : '[Deleted]'} headerStyle={{ background: '#f9fafb' }}/>
                <Column field="brand_name" header="Brand" body={({brand_name})=> brand_name ? brand_name : '[Deleted]'} headerStyle={{ background: '#f9fafb' }}/>
                <Column header="Stock Level" body={({available_stock, reorder_point})=> helpers.displayStockLevel(available_stock, reorder_point)} headerStyle={{ background: '#f9fafb' }}/>
                <Column field="available_stock" header="Available" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="reorder_point" header="Reorder&nbsp;Level" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="unit_name" header="Unit" body={({unit_name})=> unit_name ? unit_name : ''} headerStyle={{ background: '#f9fafb' }}/>
                <Column header="Price" body={({product_price})=> getPrice(product_price)} headerStyle={{ background: '#f9fafb' }}/>
                <Column header="Cost " body={({product_cost})=> getPrice(product_cost)} headerStyle={{ background: '#f9fafb' }}/>
                <Column field="status_name" header="Status" headerStyle={{ background: '#f9fafb' }}/>
                <Column field="package_weight" header="Package&nbsp;Weight" 
                    body={({package_weight, weight_unit})=> package_weight ? `${package_weight}${weight_unit}`: ''} 
                    headerStyle={{ background: '#f9fafb' }}/>
                <Column field="package_length" header="Length" body={({package_length, volume_unit})=> package_length ? `${package_length}${volume_unit}` : ''} headerStyle={{ background: '#f9fafb' }}/>
                <Column field="package_width" header="Width" body={({package_width, volume_unit})=> package_width ? `${package_width}${volume_unit}` : ''} headerStyle={{ background: '#f9fafb' }}/>
                <Column field="package_height" header="Height" body={({package_height, volume_unit})=> package_height ? `${package_height}${volume_unit}` : ''} headerStyle={{ background: '#f9fafb' }}/> */}
            </DataTable>
        )

    }

    const onPage = (e) => {
        setFilters(e)
        //setSelectedItems([])
    };

    function getPrice(data){
        return <>&#8369; {helpers.formatAmount(data)}</>
    }

    return (
        <Layout page_title="Stock Item Report" menu="reports" parent_link='/reports' parent_text="Reports">
            <div className="container-fluid">
                <div className='mb-4'>
                    <Link to="/reports" className="btn btn-outline-dark border"><i className="fas fa-arrow-left mr-2" /> Reports</Link>
                    <button type="button" className='btn bg-purple text-right float-right' onClick={exportReport} disabled={!data_loaded}><i className="fas fa-file-excel mr-2" />Export</button>
                </div>
            </div>

            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>

                <Accordion>
                    <AccordionTab header="Filters" className="text-dark" unstyled={true}>
                        <div className="row">
                            <div className="col-md-4 col-lg-3 mb-2">
                                <label>Request Dates</label><br/>
                                <Calendar 
                                    value={filters.dates} 
                                    onChange={inputDateChange} 
                                    dateFormat="yy-mm-dd"
                                    selectionMode="range" 
                                    readOnlyInput 
                                    hideOnRangeSelection 
                                    className='w-100'
                                    showButtonBar
                                    placeholder='Order Date Range'
                                />
                            </div> 
                            {
                                filter_by === 'stock' || filter_by === 'custom' ?
                                <div className="col-md-4 col-lg-3 mb-2">
                                <DropDownSelection
                                    tagClass="form-control"
                                    id="stock_level"
                                    name='stock_level' 
                                    placeholder='Select Stock Level'
                                    value={filters.stock_level}  
                                    onChange={inputChange}
                                    onFocus=""
                                    optionList={store.stock_level}
                                    optionProps ={{value:'id', label:'label'}}
                                    label={<>Stock Level</>}
                                />
                                </div> : ''
                            }
                            {
                                filter_by === 'category' || filter_by === 'custom' ?
                                <div className="col-md-4 col-lg-3 mb-2">
                                <DropDownSelection
                                    tagClass="form-control"
                                    id="category"
                                    name='category' 
                                    placeholder='Select Category'
                                    value={filters.category}  
                                    onChange={inputChange}
                                    onFocus=""
                                    optionList={enums.category_list}
                                    optionProps ={{value:'id', label:'category_name'}}
                                    label={<>Category</>}
                                /></div> : ''
                            }
                            {
                                filter_by === 'brand' || filter_by === 'custom' ?
                                <div className="col-md-4 col-lg-3 mb-2">
                                <DropDownSelection
                                    tagClass="form-control"
                                    id="brand"
                                    name='brand' 
                                    placeholder='Select Brand'
                                    value={filters.brand}  
                                    onChange={inputChange}
                                    onFocus=""
                                    optionList={enums.brand_list}
                                    optionProps ={{value:'id', label:'brand_name'}}
                                    label={<>Brand</>}
                                /></div> : ''
                            }
                            {
                                filter_by === 'product_type' || filter_by === 'custom' ?
                                <div className="col-md-4 col-lg-3 mb-2">
                                <label>Type</label><br/>
                                <ButtonGroupSelection
                                    tagClass="form-control"
                                    containerClass="btn-group w-100"
                                    id="product_type"
                                    name='product_type' 
                                    value={filters.product_type}  
                                    onChange={inputChange}
                                    onFocus=""
                                    optionList={store.product_type}
                                    optionProps ={{value:'id', label:'label'}}
                                /></div> : ''
                            }
                        

                            {
                                filter_by === 'product_status' || filter_by === 'custom' ?
                                <div className="col-md-4 col-lg-3 mb-2">
                                    <label>Status</label><br/>
                                <ButtonGroupSelection
                                    tagClass="form-control"
                                    containerClass="btn-group w-100"
                                    id="product_status"
                                    name='product_status' 
                                    value={filters.product_status}  
                                    onChange={inputChange}
                                    onFocus=""
                                    optionList={store.product_status}
                                    optionProps ={{value:'id', label:'label'}}
                                />
                                </div> : ''
                            }
                            <div className="col-md-4 col-lg-3 mb-2">
                                <label>Search</label>
                                <input type="text" className="form-control" placeholder="Search" onChange={search} />
                            </div>
                        </div>
                    </AccordionTab>
                </Accordion>

                <div className="card card-primary card-outline mt-3">
                    <div className="card-body p-0">
                        { data_table }
                    </div>
                </div>
            </div>
        </Layout>
    )
}